import useLockBodyScroll from "@/hooks/useLockBodyScroll";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaEye } from "react-icons/fa"
import ReviewBodyModal from "./ReviewBodyModal";
import { Order } from "@/types/ApiTypes";
import { useUserRole } from "@/hooks/useUserRole";
interface ReviewBodyProps {
    order: Order;
}
export default function ReviewBody({ order }: ReviewBodyProps) {
    const {isBranchAdmin,openAppReviewBasedOnRole} = useUserRole()
    const { t } = useTranslation();
    const [modalOpen, setModalOpen] = useState(false);
    const toggleModal = () => {
        setModalOpen(!modalOpen);

        if(isBranchAdmin && !modalOpen){
            openAppReviewBasedOnRole()
        }

    };

    useLockBodyScroll(modalOpen);
    return (
        <>
            {modalOpen && (<ReviewBodyModal toggleModal={toggleModal} order={order} />)}
            <tr>
                <td className="px-6 py-4 border-b">
                    {order.customer.name} 
                </td>
                <td className="px-6 py-4 border-b">
                    {order._id} 
                </td>
                <td dir="rtl"  className="px-6 py-4 border-b">
                    {order.review?.rating} ⭐
                </td>
                <td dir="rtl"  className="px-6 py-4 border-b ">
                    {order.review?.driverRating ? order.review.driverRating +" ⭐" : "-"} 
                </td>
                <td  dir="rtl" className="px-6 py-4 border-b ">
                    {order.review?.average} ⭐
                </td>
                <td className="px-6 py-4 border-b">
                    <span
                        onClick={toggleModal}
                        className="px-2 py-[2px] rounded-xl w-16 transition-colors duration-200 text-white cursor-pointer text-center hover:bg-blue-700 bg-blue-600 text-[10px] flex justify-center items-center mx-auto gap-1">{t("ordersBody.Preview")}<FaEye className="text-sm" /></span>
                </td>
            </tr>
        </>
    )
}
